import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Button, Chip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IconButton from "@mui/material/IconButton";
import { deletePopPlan } from "../../Services/Brokerage"; // adjust path if
import { supabase } from "../../supabaseClient";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { errorTost, successTost } from '../../Services/Toast'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
// ❌ remove navigate
// import { useNavigate } from "react-router-dom";

import { getPopPlans } from "../../Services/Brokerage";
import CreatePopWizard from "./CreatePopWizard"; // 🔥 add this

const ProjectOperatingPlan = () => {
  // const navigate = useNavigate(); ❌ remove
  const [popList, setPopList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false); // 🔥 add
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const fetchPopPlans = async () => {
    try {
      setLoading(true);

      const plans = await getPopPlans();

      // 🔥 get all pop_plan_ids which have payout entries
      const { data: payoutData, error } = await supabase
        .from("CpPayoutLedger")
        .select("pop_plan_id")
        .not("pop_plan_id", "is", null);

      if (error) throw error;

      const payoutSet = new Set(payoutData.map((item) => item.pop_plan_id));

      const updatedPlans = plans.map((plan) => ({
        ...plan,
        hasPayout: payoutSet.has(plan.id),
      }));

      setPopList(updatedPlans);
    } catch (error) {
      console.error("Failed to fetch POP plans", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPopPlans();
  }, []);
  const handleDeleteClick = (id) => {
    setSelectedPlanId(id);
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const res = await deletePopPlan(selectedPlanId);

      if (res?.blocked) {
        alert(res.message);
        setOpenDeleteDialog(false);
        return;
      }

      if (res?.success) {
        fetchPopPlans();
        successTost("POP plan deleted successfully");
      }
    } catch (error) {
      console.error("Delete failed", error);
    } finally {
      setOpenDeleteDialog(false);
      setSelectedPlanId(null);
    }
  };
  const handleViewClick = (plan) => {
    setSelectedPlan(plan);
    setOpenViewDialog(true);
  };
  const formatIndian = (value) => {
    if (value === null || value === undefined) return "∞";
    return Number(value).toLocaleString("en-IN");
  };
  return (
    <Box p={1}>
      {/* HEADER (UNCHANGED ✅) */}
      {/* <Box display="flex" alignItems="center" gap={2} mb={3}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: "12px",
            backgroundColor: "#EEF4FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DescriptionOutlinedIcon sx={{ color: "#59a5fc" }} />
        </Box>

        <Box>
          <Typography fontSize={20} fontWeight={600}>
            Project Operating Plan (POP)
          </Typography>
          <Typography fontSize={14} color="text.secondary">
            Incentivize CPs for specific projects, wings, or units.
          </Typography>
        </Box>
      </Box> */}

      {/* 🔥 IF CREATE MODE → SHOW FORM BELOW HEADER */}
      {showCreate ? (
        <CreatePopWizard
          onCancel={() => setShowCreate(false)}
          onSuccess={() => {
            setShowCreate(false);
            fetchPopPlans(); // refresh list
          }}
        />
      ) : (
        <>
          {/* SUB HEADER (UNCHANGED ✅) */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
          >
            <Typography fontSize={16} fontWeight={600}>
              Active POP Configurations
            </Typography>

            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                textTransform: "none",
                borderRadius: "10px",
                px: 2.5,
              }}
              onClick={() => setShowCreate(true)} // 🔥 replaced navigate
            >
              Create New POP
            </Button>
          </Box>

          {/* CONTENT (UNCHANGED ✅) */}
          {loading ? (
            <Typography>Loading POPs...</Typography>
          ) : popList.length === 0 ? (
            <Typography>No POP configurations found</Typography>
          ) : (
            <Box display="flex" flexDirection="column" gap={2}>
              {popList.map((pop) => (
                <Paper
                  key={pop.id}
                  elevation={0}
                  sx={{
                    borderRadius: "14px",
                    
                    border: "1px solid #E5E7EB",
                    p: 2.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      left: 0,
                      top: 0,
                      bottom: 0,
                      width: "4px",
                      borderRadius: "14px 0 0 14px",
                    }}
                  />

                  <Box display="flex" gap={2} alignItems="flex-start">
                    <Box
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: "12px",
                        backgroundColor: "#EEF4FF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <DescriptionOutlinedIcon sx={{ color: "#59a5fc" }} />
                    </Box>

                    <Box>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography fontWeight={600}>{pop.title}</Typography>

                        {pop.active && (
                          <Chip
                            label="Active"
                            size="small"
                            sx={{
                              backgroundColor: "#DCFCE7",
                              color: "#15803D",
                              fontWeight: 500,
                            }}
                          />
                        )}
                      </Box>

                      <Typography fontSize={14} color="text.secondary" mt={0.5}>
                        {pop.project} • {pop.type} • {pop.scope}
                      </Typography>

                      <Typography fontSize={13} color="text.secondary" mt={0.5}>
                        👥 {pop.cps}
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" alignItems="center" gap={3}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <CalendarTodayOutlinedIcon
                        sx={{ fontSize: 16, color: "#6B7280" }}
                      />
                      <Box>
                        <Typography fontSize={13}>{pop.validity}</Typography>
                        <Typography fontSize={12} color="text.secondary">
                          Validity Period
                        </Typography>
                      </Box>
                    </Box>


                    {/* VIEW ICON */}
                    <IconButton
                      onClick={() => handleViewClick(pop)}
                      sx={{
                        color: "#2563EB",
                        width: 40,
                        
                        height: 40,
                      }}
                    >
                      <VisibilityOutlinedIcon sx={{ fontSize: 22 }} />
                    </IconButton>

                    {/* DELETE ICON */}
                    {!pop.hasPayout && (
                      <IconButton
                        onClick={() => handleDeleteClick(pop.id)}
                        sx={{
                          color: "#DC2626",
                          width: 40,
                          height: 40,
                        }}
                      >
                        <DeleteOutlineIcon sx={{ fontSize: 22 }} />
                      </IconButton>
                    )}
                  </Box>
                </Paper>
              ))}
            </Box>
          )}
        </>
      )}
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Delete POP Plan?</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this POP plan? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenDeleteDialog(false)}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            color="error"
            sx={{ textTransform: "none" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openViewDialog}
        onClose={() => setOpenViewDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>POP Configuration</DialogTitle>

     <DialogContent>
  {selectedPlan && (
    <Box display="flex" flexDirection="column" gap={2}>

      {/* 🔥 TWO COLUMN GRID */}
      <Box
        display="grid"
        gridTemplateColumns="1fr 1fr"
        gap={2}
      >
        <Typography><b>Name:</b> {selectedPlan.title}</Typography>
        <Typography><b>Project:</b> {selectedPlan.project}</Typography>

        <Typography><b>Type:</b> {selectedPlan.type}</Typography>
        <Typography><b>Scope:</b> {selectedPlan.scope}</Typography>

        <Typography><b>Channel Partners:</b> {selectedPlan.cps}</Typography>
        <Typography><b>Validity:</b> {selectedPlan.validity}</Typography>

        <Typography><b>Status:</b> {selectedPlan.active ? "Active" : "Inactive"}</Typography>
        <Typography><b>Calculation Basis:</b> {selectedPlan.calculationBasis}</Typography>

        <Typography><b>Reward Type:</b> {selectedPlan.rewardType}</Typography>
      </Box>

      {/* SLABS SECTION */}
      <Box mt={2}>
        <Typography fontWeight={600} mb={1}>
          Slab Rules
        </Typography>

        {selectedPlan.slabs?.length > 0 ? (
          selectedPlan.slabs.map((slab) => (
            <Box
              key={slab.id}
              display="flex"
              justifyContent="space-between"
              border="1px solid #E5E7EB"
              borderRadius="8px"
              px={2}
              py={1}
              mb={1}
            >
              <Typography>
                {selectedPlan.calculationBasis?.toUpperCase() === "VALUE"
                  ? `₹${formatIndian(slab.from_value)} - ₹${formatIndian(slab.to_value)}`
                  : `${formatIndian(slab.from_value)} - ${formatIndian(slab.to_value)} Deals`}
              </Typography>

              <Typography fontWeight={600}>
                {selectedPlan.rewardType?.toUpperCase() === "PERCENTAGE"
                  ? `${slab.percentage ?? 0}%`
                  : `₹${formatIndian(slab.amount)}`}
              </Typography>
            </Box>
          ))
        ) : (
          <Typography color="text.secondary">
            No slabs configured
          </Typography>
        )}
      </Box>

    </Box>
  )}
</DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProjectOperatingPlan;
